export const AdminConstant = {
    organization: {
        create: 'RepoAccess/createOrganization',
        get: 'RepoAccess/getOrganization',
        update: 'RepoAccess/updateOrg',
        disable: 'RepoAccess/disableOrg',
    },
    clientManagement: {
        getInsertConstant: 'Admin/ClientInsert',
        getClientListConstant: 'Admin/ClientSelect?ClientId=null',
        getClientUpdateConstant: 'Admin/ClientUpdate',
        getAdminLogConstant: 'Admin/AdminlogInsert',
    },
    userManagement: {
        getClientBuSelect: 'Client/ClientBuSelect?clientId=null',
        getUserBypattern: 'Client/GetUserByPattern',
        getInsertManagement: 'AAD/AddAdUser',
        getSecUserUpdate: 'Client/SecUserUpdate',
        getDeleteUser: 'Client/deleteUser?Email=',
        getAccessByUser: 'Client/GetUserAccessByUser?Email='
    },
    userRoles: {
        getRoles: 'Admin/SecRolesSelect?module_name=',
        MultipleAccessForProject: 'Client/MultipleAccessForProject'
    },
    imageManagement: {
        getFetchRepoList: 'RepoAccess/fetchRepoPipeline',
        getTriggerPipeline: 'RepoAccess/TriggerPipeline',
        getOrganizationList: 'RepoAccess/getOrganization',
        getImages: 'Client/SelectImagesHistory?clientid=',
        getProjects: 'RepoAccess/GetProjects?organization=',
        getPipelineList: 'RepoAccess/FetchPipelines',
        getArcImages: 'DNS/GetImageOfRepo',
        getAllACRRepo: 'DNS/GetAllACRRepo',
        getBrancheList: 'RepoAccess/GetBranches',
        getRepoList: 'RepoAccess/GetReposiotries',
        getAddPipeline: 'RepoAccess/addRepoPipeline',
        versionInsert: 'Admin/VersionInsert',
        fetchComponentVersions: 'Admin/FetchComponentVersions',
        InsertComponentVersion: 'Admin/ComponentDeploymentInsert',
        FetchQmigVersionByProject: 'Admin/FetchQmigVersionByProject',
        FetchImageVersionInfo: 'Admin/get_latest_image',
        FetchlatestImageInfo: 'Admin/get_latest_imageby_rn',
        clientQuadUpdate: 'Admin/ClientQuadUpdate',
        kubeSetImages: 'kube/setimage',
        getCronDeployImages: 'Kube/getCronDeployImages',
        deleteImagesOfRepo: 'DNS/DeleteImagesOfRepo',
    },
    licenseKeys: {
        getInsertProjectKey: 'Client/projectKeyInsertwithEmail',
        getRemoveProjectKey: 'Client/deleteProjectKey?keyId=',
        getKeydetails: 'Client/getKeyDetails?projectId=',
        getSendKey: 'Sec/SendKeyInfo',
        getProjectSelectConstant: 'Client/GetProjectList',
    },
    acrAccess: {
        getServicePrinciple: 'Service/createsp?projectname=',
    },
    dnsMapping: {
        getDNSMappingID: 'DNS/DNSMapping',
        getProjectURLS: 'Client/SelectProjectURLs?projectId=',
    },
    addOrganization: {
        getCreateOrg: 'RepoAccess/createOrganization',
        getUpdateOrg: 'RepoAccess/updateOrg',
        getDisableOrg: 'RepoAccess/disableOrg?id=',
        saveDefaultBranch: 'Admin/InsertOrgRepoDetails',
        saveAssociateBranch: 'Admin/InsertProjectBranchDetails',
        fetchABOrganization: 'Admin/GetOrgRepoDetails?component_type=',
        GetProjectBranchDetails: 'Admin/GetProjectBranchDetails',
        UpdateProjectBranchDetails: 'Admin/UpdateProjectBranchDetails?id='
    },
    repoApproval: {
        getAdmins: 'RepoAccess/GetAdmins',
        getRepoRequests: 'RepoAccess/GetUserRepoRequests',
        getUpdateRequest: 'RepoAccess/updateRequest',
        getChangeAccessToBasic: 'RepoAccess/changeAccessToBasic',
        getBasicAccessList: 'RepoAccess/GetBasicUsers?organization=',
        getRepoUsers: 'RepoAccess/GetUser?organization=',
        getChangeAccessToStakeHolder: 'RepoAccess/changeAccess',
    },
    gitCopy: {
        getAllCommits: 'RepoAccess/getAllCommitswithInDates',
        getUpdateStatus: 'RepoAccess/updateStatusForCopy',
        getCopyIndividual: 'RepoAccess/CommitFilesIndividually',
        getRepos: 'RepoAccess/GetReposiotries',
    },
    repoRequest: {
        getUserRepoRequest: 'RepoAccess/UserRepoRequest'
    },
    Kubernetes: {
        getDeploymentsBatch: "Kube/getDeploymentsBatch",
        scaleDeployment: "Kube/scaleDeployment",
        getLicenseDetails: "Admin/GetLicenseDetails?migid=",
        isLicenseExpired: "Admin/IsLicenseExpired?migid=",
        GetProjectToken: 'Admin/GetProjectToken?ProjectId=',
        ProjectUrlsUpdate: "Admin/ProjectUrlsUpdate",
    },
    vacuum: {
        tgtSchemaSelectwithdb: 'Admin/GetPgSchemaswithDb?ConId=',
        getConnections: 'GetConnectionList?projectId=',
        getdbnames: 'Admin/GetDbnames?conId=',
        triggerVacuum: 'DBACommand',
        GetReqData: 'Admin/GetRequestTableData?projectId=',
        deleteTableData: 'Admin/DeleteRequestTableData?projectId=',
        FetchVacuumData: 'Admin/FetchVacuumData?ConId=',
        GetAnalyzeData: 'Admin/FetchAnalyzeData?ConId=',
        etchVacuumData: 'Admin/FetchVacuumData?ConId=',
        Vacuumschema: 'Admin/Vacuumschema?schema=',
        Analyzeschema: 'Admin/Analyzeschema?schema=',
        TriggerDBA: 'Admin/TriggerDBACommand',
        GetFilesFromDir: 'Admin/GetFilesFromDirectory?path=',
        GetDBAFiles: 'Admin/GetDBAFiles?path=',
        GetFolders: 'Admin/GetFolders?path=',
    },
    connection: {
        addProjectObject: 'Admin/AddConnectionwithUserId',
        srcTgtConfSelectInsert: 'Project/srcTgtConfSelectInsert',
        GetDBConnections: 'Admin/GetConnectionInfo',
        UpdateConnection: 'Admin/UpdateConnectionwithUserId',
        deleteDbConnection: 'Admin/DeleteDBConnection?projectId=',
        ClientProjectInsert: 'Admin/ClientProjectInsert',
        UserInsert: 'Admin/UserInsert',
    },
    release: {
        FetchComponentData: 'Admin/FetchComponentData',
        FetchQmigVersion: 'Admin/select_version?clientId=',
        GetImages: 'DNS/GetImageOfRepoList',
        insertComponent: 'Admin/InsertComponentVersion',
        updateComponent: 'Admin/close_releaseortask?id=',
        insertComponentDeployment: 'Admin/InsertComponentDeploy',
        updateComponentDeployment: 'Admin/deploy_status_update',
        getComponents: 'Admin/GetComponentDataByDate?startdate=',
        getComponentVersions: 'Admin/GetComponentVersionData',
        getReleaseOwners: 'AAD/GetAllUsers',
        releaseCreate: 'Admin/insert_release',
        insertComponentLevelData: 'Admin/insert_task',
        updateComponentDeploymentData: 'Admin/insert_deployment',
        createFeatureBranch: 'RepoAccess/createFeatureBranch',
        createPullRequest: 'RepoAccess/createPullRequest',
        insertIntegrationBranch: 'Admin/InsertIntegrationBranchData',
        getComponentsByModules: 'Admin/get_components?module_name=',
        GetPullRequest: 'RepoAccess/GetPullRequest',
        GetModulesByProjectType: 'Admin/GetModulesByProjectType?prj_type_id=',
        GetPullRequestByComponentType: 'RepoAccess/GetPullRequestByComponentType?component_type=',
        GetComponentDateByOwner: 'Admin/GetComponentDateByOwner',
        getSuggestedReleases: 'Admin/GetCompletedReleaseData?projectId=',
        getTaskByOwner: 'Admin/get_task_by_owner',
        getStatusTasksByTaskID: 'Admin/get_task_by_task_id?id=',
        addStatusTask: 'Admin/insert_task_status',
        GetReleaseByProjectTypeId: 'Admin/GetReleaseByProjectTypeId?projecttype_id=',
        Get_task_componenttypeData: 'Admin/Get_task_componenttypeData?releaseid=',
        Get_task_Data: 'Admin/Get_task_Data?releaseid=',
        Get_release_data: 'Admin/Get_release_data?releaseid=',
        Get_task_status_by_owner: 'Admin/get_task_status_by_owner',
        UpdateRelease: 'Admin/UpdateRelease',
        UpdateTask: 'Admin/UpdateTask',
        GetReleaseByProjectId: 'Admin/get_release_by_project_id?projectId='
    },
    dba: {
        getAgent: 'Admin/dba-agent',
        getPerAgent: 'performance-agent',
        clearChatHistory: 'clear-history',
    },
    monitoring: {
        DBAScriptInsertion: 'Admin/DBAScriptInsertion',
        DBATaskList: 'Admin/DBATaskList?projectId=',
        DBACategoryName: 'Admin/DBACategoryName?category=',
        GetServerParamsData: 'Admin/GetServerParamsData?conid=',
        QueryExecution: 'Admin/QueryExecution',
        GetDBARunids: 'Admin/GetDBAScriptRunids',
        GetDBAExeResults: 'Admin/GetDBAScriptResultsByRunid?runid=',

        GetbloatingDetails: 'Admin/GetbloatingDetails',
        downloadLargeFiles: 'Admin/DownloadLargeFile?filePath=',
        getusers: 'Admin/GetUsers?ConId=',
        getroles: 'Admin/GetRoles?ConId=',
        getobjecttype: 'Admin/GetObjectTypes',
        getobjectnames: 'Admin/GetObjects',
        getexecutedata: 'Admin/GetExecutedata?ConId=',
        getpermissions: 'Admin/GetPermissions',
        grantpermissions: 'Admin/GrantPermissions',
        uploadLargeFiles: 'Admin/UploadCloudFiles',
        deleteFile: 'Admin/DeleteFiles?path=',
        UploadExtraFiles: 'Admin/UploadAutomationFiles',
        GetTryNowFilesFromDir: 'Admin/GetautomationFiles?path='
    },
    resourcemanagement: {
        GetResources: 'ARM/GetResources',
        UpdateShutdownTag: 'ARM/UpdateShutdownTag',
        StartStopResource: 'ARM/StartStopResource',
        GetAutomationVar: 'ARM/GetAutomationVar',
        UpdateAutomationVar: 'ARM/SetAutomationVar'
    },
    leadership: {
        GetWorkloadDetails: 'Leadership/GetWorkloadDetails',
        ExecuteRequestSummaryInUpNamespaces: 'Leadership/ExecuteRequestSummaryInUpNamespaces',
        UpsertWorkloadByName: 'Leadership/UpsertWorkloadByName',
        UpsertWorkloadProjectMap: 'Leadership/UpsertWorkloadProjectMap',
        UpsertWorkloadProjectStatus: 'Leadership/UpsertWorkloadProjectStatus',
        UpsertWorkloadReleaseMap: 'Leadership/UpsertWorkloadReleaseMap',
    }
}